import React from 'react';
import { injectIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';

@injectIntl
export default class Unauthorized extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Alert bsStyle="warning">
                <strong>Hmm...</strong>  {this.props.intl.formatMessage({ id: 'unauthorized' })}
            </Alert>
        )
    }
}
